import { ButtonType, Delete, Description, Heading, IconButtonSize, IconSize, OverlayMode, Section, Button, IconButton } from '@soteria/design-system-ve';

import * as styles from './CommunityGroupHeader.css.ts';
import { CommunityGroupStats } from './CommunityGroupStats';

interface CommunityGroupHeaderProps {
  name: string;
  description?: string;
  createdAt: string;
  lastModifiedAt: string;
  createdBy: string;
  communitiesCount: number;
  isCommunityGroupAdmin: boolean;
  onDeleteGroup: () => void;
  onAddCommunity: () => void;
}

export function CommunityGroupHeader({
  name,
  description,
  createdAt,
  lastModifiedAt,
  createdBy,
  communitiesCount,
  isCommunityGroupAdmin,
  onDeleteGroup,
  onAddCommunity,
}: CommunityGroupHeaderProps) {
  const canDeleteGroup = communitiesCount === 0;
  const deleteButtonAriaLabel = canDeleteGroup ? 'Delete this community group' : 'Cannot delete a group that has communities';

  return (
    <Section spacing="medium">
      <Heading className={styles.groupDetailPageHeadingStyle} level="h1">
        {name}
      </Heading>

      {description && (
        <div className={styles.descriptionContainerStyle}>
          <Description>{description}</Description>
        </div>
      )}

      <CommunityGroupStats
        backgroundColor="transparent"
        stats={[
          { label: 'Created', value: createdAt, size: 'small', variant: 'success' },
          { label: 'Last Modified', value: lastModifiedAt, size: 'small', variant: 'success' },
          { label: 'Created By', value: createdBy, size: 'small', variant: 'success' },
          { label: 'Communities', value: communitiesCount.toString(), size: 'small', variant: 'success' },
        ]}
      />

      <div className={styles.actionsContainerStyle}>
        {isCommunityGroupAdmin && (
          <>
            {/* Add Community button - available to admins */}
            <Button buttonType={ButtonType.Brand} overlayMode={OverlayMode.Solid} onClick={onAddCommunity}>
              ADD COMMUNITY
            </Button>

            {/* Delete Group button - only available to admins */}
            <IconButton
              aria-label={deleteButtonAriaLabel}
              buttonSize={IconButtonSize.XLarge}
              buttonType={ButtonType.Danger}
              disabled={!canDeleteGroup}
              icon={Delete}
              iconSize={IconSize.XSmall}
              overlayMode={OverlayMode.Solid}
              onClick={onDeleteGroup}
            />
          </>
        )}
      </div>
    </Section>
  );
}
